module.exports = __webpack_public_path__ + "img/rectangles-mixed.88721b92.svg";